 function renderWishlistCounter(swat) {
    var counterElements = document.querySelectorAll(".swym-wishlist-header-counter");

    if (counterElements.length > 0) {
      for (var i = 0; i < counterElements.length; i++) {
        var element = counterElements[i];
        if (swat.renderWishlistCount) {
          swat.renderWishlistCount(element, function (count, element) {
            console.log("debug - renderWishlistCount", count, element);

            if (count > 0) {
              element.style.display = "flex"; // Show counter if there are items
              element.textContent = count; // Update the counter value
            } else {
              element.style.display = "none"; // Hide counter when no items
            }
          });
        }
      }
    }
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(renderWishlistCounter);